import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { messagesBackend } from './messages.backend';
import { MessagesEffect } from './messages.effect';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { messagesReducer } from './messages.reducer';

// FIXME: remove that
backend.messages = messagesBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('messages', messagesReducer),
    EffectsModule.forFeature([MessagesEffect]),
    /* DatastoreBackendModule.forFeature(
      'messages',
      messagesBackend,
    ),*/
  ],
})
export class DatastoreMessagesModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/messages/messages.module.ts